import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import BrandLogo from "@/components/BrandLogo";
import { useBranding } from "@/context/BrandingContext";

export default function ConfirmEmail() {
  const { applyNeutral, exitNeutral } = useBranding();
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "loading" });

  useEffect(() => { applyNeutral(); return () => exitNeutral(); }, [applyNeutral, exitNeutral]);

  useEffect(() => {
    api.post("/auth/verify-email", { token: params.get("token") || "" })
      .then((r) => setState({ status: "ok", email: r.data.email }))
      .catch((e) => setState({ status: "error", message: apiError(e.response?.data?.detail) || "Lien invalide" }));
  }, [params]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-dd-night p-6">
      <div className="w-full max-w-md bg-white rounded-lg p-8" data-testid="confirm-page">
        <div className="mb-6"><BrandLogo className="h-12" /></div>
        {state.status === "loading" && <p className="text-sm text-dd-warm">Confirmation en cours…</p>}
        {state.status === "ok" && (
          <div data-testid="confirm-ok">
            <h2 className="text-2xl font-bold text-dd-blue">Adresse confirmée</h2>
            <p className="mt-3 text-sm text-dd-night">Votre compte <strong>{state.email}</strong> est actif. Vous pouvez vous connecter et configurer votre gérance dans Réglages (logo, couleurs, coordonnées).</p>
          </div>
        )}
        {state.status === "error" && (
          <div data-testid="confirm-error">
            <h2 className="text-2xl font-bold text-destructive">Lien invalide</h2>
            <p className="mt-3 text-sm text-dd-night">{state.message}</p>
          </div>
        )}
        <Link to="/login" className="mt-6 block h-11 leading-[44px] text-center rounded-md bg-dd-blue text-white text-sm" data-testid="confirm-login-link">Se connecter</Link>
      </div>
    </div>
  );
}
